export default __webpack_public_path__ + "media/images/landing-41-550x420-0661931f84e764a676f4763cd000c1e3.jpg";